// extracted by mini-css-extract-plugin
module.exports = {"prev":"housingPromotions_prev__x5lJC","next":"housingPromotions_next__14YIu"};